"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const styled_components_1 = __importDefault(require("styled-components"));
const TwitchEmbedWrapper = styled_components_1.default.div `
    height: 100%;
    .twitch-preview-anchor {
        img {
            width: 100%;
            height: auto;
        }
    }
    iframe {
        width: 100%;
        height: 100%;
    }
`;
/**
 * TwitchVideoEmbed.
 */
class TwitchVideoEmbed extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        /**
         * Manually create and append the iframe so that each widget can have a unique ID.
         * This is required for when there are multiple frames on the same page.
         */
        this.componentDidMount = () => {
            const iframe = window_or_global_1.default.document.createElement('iframe');
            iframe.src = this.getStreamSrc();
            iframe.id = `twitch-${this.props.channel || this.props.video}${this.props.videoId || ''}`;
            iframe.className = 'twitch-video embed-responsive-item';
            iframe.frameBorder = '0';
            iframe.allowFullscreen = '1';
            iframe.title = 'Twitch video player';
            iframe.referrerPolicy = 'no-referrer';
            iframe.onload = this.onFrameLoaded;
            this.container.appendChild(iframe);
        };
        this.onFrameLoaded = event => {
            this.target = event.target;
        };
    }
    getStreamSrc() {
        const streamSrc = 'https://player.twitch.tv/';
        const defaultParentString = 'epicgames-gamedev.ol.epicgames.net&parent=fortnite.com&parent=epicgames.com';
        const parents = this.props.parentOptions
            ? this.props.parentOptions.join('&parent=')
            : defaultParentString;
        if (this.props.channel) {
            return `${streamSrc}?channel=${this.props.channel}&parent=${parents}`;
        }
        return `${streamSrc}?video=${this.props.video}`;
    }
    render() {
        let previewImg;
        if (this.props.isLauncher) {
            const href = this.getStreamSrc();
            previewImg = (react_1.default.createElement("a", { href: href, target: "_blank", className: "twitch-preview-anchor", rel: "noopener noreferrer" },
                react_1.default.createElement("img", { alt: "", src: this.props.previewImg })));
        }
        const className = (0, classnames_1.default)('twitch-video-embed embed-responsive embed-responsive-16by9', {
            channel: this.props.channel,
            stream: !this.props.channel
        });
        return (react_1.default.createElement(TwitchEmbedWrapper, { className: className, ref: c => {
                this.container = c;
            } }, previewImg));
    }
}
TwitchVideoEmbed.propTypes = {
    channel: prop_types_1.default.string,
    video: prop_types_1.default.string,
    isLauncher: prop_types_1.default.bool,
    previewImg: prop_types_1.default.string,
    videoId: prop_types_1.default.string,
    parentOptions: prop_types_1.default.array
};
exports.default = TwitchVideoEmbed;
//# sourceMappingURL=TwitchVideoEmbed.js.map